import { NewsNoticesTable } from "@/components/news-notices/news-notices-table";
import { createFileRoute } from "@tanstack/react-router";

function NoticesPage() {
  return <NewsNoticesTable />;
}

export const Route = createFileRoute("/_authenticated/website/notices/")({
  component: NoticesPage,
});
